import {Component, OnDestroy, OnInit} from '@angular/core';
import {takeUntil} from "rxjs/operators";
import {ActivatedRoute, Router} from "@angular/router";
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {Subject} from "rxjs";
import {OrbitaxExcelMemoService} from "../../orbitax-excel-memo.service";

@Component({
    standalone: false,
    selector: 'particle-excel-view-memo',
  templateUrl: './excel-view-memo.component.html',
  styleUrls: ['./excel-view-memo.component.scss']
})
export class ExcelViewMemoComponent implements OnInit, OnDestroy {
  unsubscribe$ = new Subject<void>();
  id: string;
  memoHtml: string = '';
  private memoType: string;

  constructor(private excelMemoService: OrbitaxExcelMemoService,
              private activatedRoute: ActivatedRoute,
              private fuseSplashScreenService: FuseSplashScreenService,
              private router: Router) {
  }

  ngOnInit() {
    this.activatedRoute.params.pipe(takeUntil(this.unsubscribe$)).subscribe((params: any) => {
      if (params && params.memoType && params.id) {
        this.memoType = params.memoType;
        this.id = params.id;

        this.fuseSplashScreenService.show();
        this.excelMemoService.viewMemo(this.id, this.memoType).subscribe(o => {
          this.fuseSplashScreenService.hide();
          this.memoHtml = o;
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  done() {
    if (this.memoType === 'ct' || this.memoType === 'wt') {
      this.router.navigateByUrl(`rate-memo/${this.memoType}`);
    } else {
      this.router.navigateByUrl(`planning/${this.memoType}`);
    }
  }
}
